import React from 'react'
import Layout from '../shared/components/organisms/layout/layout'
import Seo from '../shared/seo'
import ContentHome from '../components/organisms/content-home/content-home'
import { graphql } from 'gatsby'

const IndexPage = props => {
  const { allContentfulVConfidentHome } = props.data

  return (
    <Layout title={allContentfulVConfidentHome.nodes[0].metaTitulo}>
      <Seo
        title={allContentfulVConfidentHome.nodes[0].metaTitulo}
        description={
          allContentfulVConfidentHome.nodes[0].metaDescripcion
            .metaDescripcion
        }
      />
      <ContentHome />
    </Layout>
  )
}

export const query = graphql`
  query homeMeta {
    allContentfulVConfidentHome {
      nodes {
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
      }
    }
  }
`

export default IndexPage
